import * as Yup from 'yup';
import { checkIsCountriesWithStatesDropdown } from 'utils/validators/countryUtils';

export const companyInitialValidationSchema = {
  companyName: Yup.string()
    .max(120, 'Company name should be 120 characters maximum')
    .companyDuplicateCheck(),
  firstName: Yup.string()
    .trim()
    .max(120, 'Primary contact first name should be 120 characters maximum'),
  lastName: Yup.string()
    .trim()
    .max(120, 'Primary contact last name should be 120 characters maximum'),
  email: Yup.string()
    .email('Email format is invalid')
    .max(120, 'Email should be 120 characters maximum')
    .companyDuplicateCheck(),
  phone: Yup.string()
    .trim()
    .max(120, 'Phone number should be 120 characters maximum'),
  country: Yup.number().nullable(),
  state: Yup.string().trim(),
  internationalStateName: Yup.string()
    .trim()
    .max(120, 'State should be 120 characters maximum'),
  city: Yup.string().trim().max(120, 'City should be 120 characters maximum'),
  internationalCityName: Yup.string()
    .trim()
    .max(120, 'City should be 120 characters maximum'),
  address: Yup.string()
    .trim()
    .max(120, 'Address should be 120 characters maximum'),
  zip: Yup.string()
    .trim()
    .max(120, 'ZIP code should be 120 characters maximum'),
};

export const getSubmitValidationSchema = () =>
  Yup.object({
    ...companyInitialValidationSchema,
    companyName:
      companyInitialValidationSchema.companyName.required('Field is required'),
    firstName:
      companyInitialValidationSchema.firstName.required('Field is required'),
    lastName:
      companyInitialValidationSchema.lastName.required('Field is required'),
    email: companyInitialValidationSchema.email.required('Field is required'),
    phone: companyInitialValidationSchema.phone.required('Field is required'),
    country:
      companyInitialValidationSchema.country.required('Field is required'),
    state: companyInitialValidationSchema.state.when('country', {
      is: (country: number) => checkIsCountriesWithStatesDropdown(country),
      then: Yup.string().required('Field is required'),
    }),
    city: companyInitialValidationSchema.city.when('country', {
      is: (country: number) => checkIsCountriesWithStatesDropdown(country),
      then: Yup.string().required('Field is required'),
    }),
    internationalStateName:
      companyInitialValidationSchema.internationalStateName.when('country', {
        is: (country: number) => !checkIsCountriesWithStatesDropdown(country),
        then: Yup.string().required('Field is required'),
      }),
    internationalCityName:
      companyInitialValidationSchema.internationalCityName.when('country', {
        is: (country: number) => !checkIsCountriesWithStatesDropdown(country),
        then: Yup.string().required('Field is required'),
      }),
    address:
      companyInitialValidationSchema.address.required('Field is required'),
    taxId: Yup.number().nullable(),
    workerFileKey: Yup.array().of(Yup.string()),
  });
